import { render } from "./DijiaNumberPoolPackage.vue?vue&type=template&id=0c582568&scoped=true"
import script from "./DijiaNumberPoolPackage.vue?vue&type=script&lang=js"
export * from "./DijiaNumberPoolPackage.vue?vue&type=script&lang=js"

import "./DijiaNumberPoolPackage.vue?vue&type=style&index=0&id=0c582568&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c582568"

export default script